"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable prefer-rest-params */
var core_1 = require("@honeybadger-io/core");
var instrument = core_1.Util.instrument, makeNotice = core_1.Util.makeNotice, globalThisOrWindow = core_1.Util.globalThisOrWindow;
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function default_1(_window) {
    if (_window === void 0) { _window = globalThisOrWindow(); }
    return {
        load: function (client) {
            if (!client.config.enableUnhandledRejection) {
                return;
            }
            instrument(_window, 'onunhandledrejection', function (original) {
                // See https://developer.mozilla.org/en-US/docs/Web/API/Window/unhandledrejection_event
                function onunhandledrejection(promiseRejectionEvent) {
                    var _a;
                    client.logger.debug('window.onunhandledrejection callback invoked', arguments);
                    if (!client.config.enableUnhandledRejection) {
                        return;
                    }
                    var reason = promiseRejectionEvent.reason;
                    if (reason instanceof Error) {
                        var notice = makeNotice(reason);
                        if (!notice.stack) {
                            notice.stack = "".concat(reason.message, "\n    at ? (unknown:0)");
                        }
                        notice.message = "UnhandledPromiseRejectionWarning: ".concat(reason);
                        client.addBreadcrumb("window.onunhandledrejection: ".concat(notice.name), {
                            category: 'error',
                            metadata: { name: notice.name, message: notice.message, stack: notice.stack }
                        });
                        client.notify(notice);
                        return;
                    }
                    var message;
                    if (typeof reason === 'string') {
                        message = reason;
                    }
                    else {
                        try {
                            message = (_a = JSON.stringify(reason)) !== null && _a !== void 0 ? _a : 'Unspecified reason';
                        }
                        catch (_err) {
                            // Circular structures (e.g. DOM nodes with React fiber expandos) can't be stringified
                            var name_1 = reason != null && reason.constructor ? reason.constructor.name : null;
                            message = name_1 ? "[".concat(name_1, "]") : Object.prototype.toString.call(reason);
                        }
                    }
                    client.notify({
                        name: 'window.onunhandledrejection',
                        message: "UnhandledPromiseRejectionWarning: ".concat(message)
                    });
                }
                return function (promiseRejectionEvent) {
                    onunhandledrejection(promiseRejectionEvent);
                    if (typeof original === 'function') {
                        original.apply(this, arguments);
                    }
                };
            });
        }
    };
}
exports.default = default_1;
//# sourceMappingURL=onunhandledrejection.js.map